import { createModel } from "@rematch/core";
import { AreaType, MarketShareFilterState } from "src/types";

import { RootModel } from ".";

const initialState: MarketShareFilterState = {
  areaType: [AreaType.IA],
  selectedPostalCodes: [],
};

export const marketShareFilter = createModel<RootModel>()({
  state: initialState as MarketShareFilterState,
  reducers: {
    changeMarketShareFilter(state, payload: Partial<MarketShareFilterState>) {
      return {
        ...state,
        ...payload,
      };
    },
    resetMarketShareFilter() {
      return { ...initialState };
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/marketShareFilter.ts